import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../components/common/PageHeader";
import StageForm from "../components/StageForm";
import { getStageById, updateStage } from "../api/stageService";
import { toast } from "react-toastify";
import { Stage } from "../types/stage.types";

const EditStage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [stage, setStage] = useState<Stage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    fetchStage(Number(id));
  }, [id]);

  const fetchStage = async (stageId: number) => {
    try {
      const res = await getStageById(stageId);
      setStage(res.data);
    } catch (error) {
      console.error("Failed to load stage", error);
      toast.error("Failed to load stage details");
      navigate("/stage");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (data: {
    stage_name: string;
    description?: string;
    is_active: boolean;
  }) => {
    try {
      await updateStage(Number(id), data);
      toast.success("Stage updated successfully");
      navigate("/stage");
    } catch (error) {
      console.error("Update stage failed", error);
      toast.error("Failed to update stage");
    }
  };

  if (loading) {
    return <div className="container mt-4">Loading...</div>;
  }

  if (!stage) return null;

  return (
    <>
      <PageHeader
        title="Edit Stage"
        breadcrumbs={[
          { label: "Home", path: "/dashboard" },
          { label: "Masters", path: "/stage" },
          { label: "Edit Stage" },
        ]}
      />

      <StageForm
        initialData={stage}
        onSubmit={handleUpdate}
        submitLabel="Update"
      />
    </>
  );
};

export default EditStage;
